import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as hookActions from 'checkout/actions/hooks';
import { toDecimals } from '../../helpers/currency';
import { inLastStep } from '../../selectors/ui';

class Facebook extends Component {
  constructor(props) {
    super(props);
    this.props.addStateTransitionHook(this.onStateTransition);
    this.props.addReservationCompleteHook(this.onReservationComplete);
    this.props.addTicketsAddedToCartHook(this.onTicketsAdded);
    this.props.addProductsAddedToCartHook(this.onProductsAdded);
    this.props.addBundlesAddedToCartHook(this.onBundlesAdded);
    this.props.addReservationStartHook(this.onReservationStart);
    this.props.addTicketsRemovedFromCartHook(this.onTicketsRemoved);
    this.props.addProductsRemovedFromCartHook(this.onProductsRemoved);
    this.props.addBundlesRemovedFromCartHook(this.onBundlesRemoved);
    this.props.addCouponSubmissionHook(this.onCouponSubmitted);
  }

  reportEvent(...args) {
    this.props.reportEvent(this.props.config.id)(...args);
  }

  render() {
    return <div></div>;
  }

  reportWholeReservationEvent = (type) => {
    this.reportEvent('track', type, {
      value: toDecimals({ amount: this.props.total.amount, currency: this.props.currency }),
      currency: this.props.currency,
      order_id: this.props.confirmationNumber,
      content_type: 'product',
      content_ids: this.getContentIds(),
    });
  };

  onReservationComplete = () => {
    const key = 'facebook_onReservationComplete_' + this.props.confirmationNumber;
    const sent = sessionStorage.getItem(key);
    if (sent !== '1') {
      this.reportWholeReservationEvent('Purchase');
      sessionStorage.setItem(key, '1');
    }
  };

  onReservationStart = () => {
    this.reportEvent('track', 'ReservationCreated');
  };

  onCouponSubmitted = (code) => {
    this.reportEvent('track', 'CouponSubmitted', {
      coupons: [{ couponCode: code }],
    });
  };

  onStateTransition = (page) => {
    if (typeof page === 'string' && page.substring(0, 9) === 'checkout-' && this.props.inLastStep) {
      this.reportWholeReservationEvent('InitiateCheckout');
    }
  };

  onTicketsAdded = (tickets) => {
    this.reportUpdateCartItemsEvent('AddToCart', 'ticket', tickets);
  };

  onProductsAdded = (products) => {
    this.reportUpdateCartItemsEvent('AddToCart', 'product', products);
  };

  onBundlesAdded = (bundles) => {
    this.reportUpdateCartItemsEvent('AddToCart', 'bundle', bundles);
  };

  onTicketsRemoved = (tickets) => {
    this.reportUpdateCartItemsEvent('RemoveFromCart', 'ticket', tickets);
  };

  onProductsRemoved = (products) => {
    this.reportUpdateCartItemsEvent('RemoveFromCart', 'product', products);
  };

  onBundlesRemoved = (bundles) => {
    this.reportUpdateCartItemsEvent('RemoveFromCart', 'bundle', bundles);
  };

  reportUpdateCartItemsEvent = (eventType, itemType, items) => {
    this.reportEvent('track', eventType, {
      currency: this.props.currency,
      value: this.getTotalCostOfItems(items),
      content_ids: this.getCartItemsIds(itemType, items),
      content_type: 'product',
    });
  };

  getCartItemsIds = (itemType, items) => {
    const type = itemType === 'ticket' ? 'level' : itemType;

    const ids = items.map((item) => {
      return `${item.event_id}-${type}-${item.id}`;
    });

    return JSON.stringify(ids);
  };

  getContentIds = () => {
    let ids = [];

    for (let i = 0; i < this.props.tickets.length; i++) {
      ids.push(this.props.tickets[i].event_id + '-level-' + this.props.tickets[i].price_level_id);
    }

    for (let i = 0; i < this.props.productSales.length; i++) {
      ids.push(this.props.productSales[i].event_id + '-product-' + this.props.productSales[i].product_id);
    }

    for (let i = 0; i < this.props.bundleSales.length; i++) {
      ids.push(this.props.bundleSales[i].event_id + '-bundle-' + this.props.bundleSales[i].bundle_id);
    }

    return JSON.stringify(ids);
  };

  getTotalCostOfItems = (items) => {
    let cost = 0;
    if (Array.isArray(items)) {
      items.forEach((item) => {
        cost += +(item?.cost?.amount ?? 0);
        cost += +(item?.buyer_fee?.amount ?? 0);
      });
    }
    return toDecimals({ amount: cost, currency: this.props.currency });
  };
}

const mapStateToProps = (state) => {
  return {
    total: state.reservation.total_cost,
    currency: state.reservation.currency,
    confirmationNumber: state.reservation.confirmation_number,
    tickets: state.tickets.tickets,
    productSales: state.productSales.products,
    bundleSales: state.bundleSales.bundles,
    inLastStep: inLastStep(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  const actions = {};
  Object.keys(hookActions).forEach((hookActionName) => {
    actions[hookActionName] = hookActions[hookActionName];
  });
  return bindActionCreators(actions, dispatch);
};

Facebook.propTypes = {
  config: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Facebook);
